import React from 'react'
import {submitSpecialTerritoryPostalCodes} from "../api/api";
import { Table, Form } from "@q4us-sw/q4us-ui";
import { getFeConfig, visualize, visualizeSpecialTerritoryPostalCodes } from "../api/api";
import {Button, Modal, Space, notification} from 'antd'
import {
    AppstoreAddOutlined,
} from "@ant-design/icons"
import TableDataSource from "../utils/TableDataSource";
import {TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";

export const SpecialTerritoryPostalCode = (props) => {

    const [open, setOpen] = React.useState(false);
    const [source, setSource] = React.useState(new TableDataSource());
    const [refresh, setRefresh] = React.useState(1);

    const regex1 = new RegExp("^.*[*].+$")

    return <React.Fragment>
        <Space direction={`vertical`} style={{width:"100%"}}>
            <div style={{textAlign: 'right', paddingRight: 7,width: '100%'}} >
                <Button style={{width: 200}} icon={<AppstoreAddOutlined/>} onClick={()=>setOpen(true)}>Add New Postal Code</Button>
            </div>
            { refresh && <TableV2
                key={refresh}
                schema={'special_territory_postal_code'}
                action={{
                    name: 'id',
                    title: 'Action',
                    options: TableOperation.Update,
                }}
                maxColumnWidth={400}
                shouldRefresh={(operation, status)=> {return operation === TableOperation.Update}}
                fetchConfig={async () => {
                    const {data= {}} = await getFeConfig('special_territory_postal_code')
                    const { statusCode, rows = [], fields = [] } = data;

                    return { data: { statusCode, rows: rows, fields } };
                }}
                scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
                fetchData={async () => {
                    { return await visualizeSpecialTerritoryPostalCodes(props.special_territory_id) }
                    }}
                saveData={async (values) => {
                    if(values.postal_code.match(regex1)){
                        notification.error({message: 'The * cannot be placed at the beginning or in the middle'})
                        return false;
                    }
                    const { data: { statusCode = 400, rows = [], message } = {} } = await submitSpecialTerritoryPostalCodes({...values, type: "update"});
                    if(statusCode === 200){
                        notification.success({message: `Record updated with Postal code`})
                    }
                    return { data: { statusCode, rows: [values] } };
                }}

                editable={true}

                source={source}
                />}
        </Space>

        <Modal
            centered
            closable={true}
            onCancel={()=>setOpen(false)}
            footer={null}
            title={`Add New Postal Code`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'special_territory_postal_code'} config={async () => {
                const res = await getFeConfig('special_territory_postal_code_form') || {}
                const { data: { rows = [] } = {} } = res;
                return rows

            }}
                  validateField={async (rule, value, schema, column, form) => {
                      if (column.name === 'postal_code') {
                          const obj = form.getFieldsValue(['postal_code']) || {};
                          const postal_code = obj['postal_code']
                          if(postal_code.match(regex1)) {
                              return Promise.reject('The * cannot be placed at the beginning or in the middle')
                          }
                      }
                      return Promise.resolve()
                  }}
                  submit={async (values) => {
                      values['type'] = 'insert';
                      values['country_code'] = props.country_code;
                      values['special_territory_id'] = props.special_territory_id;
                      const { data } = await submitSpecialTerritoryPostalCodes(values);
                      if(data.statusCode === 200){
                          notification.success({message: `New record added to special_territory_postal_code`})
                      }
                      else if(data.message.includes('duplicate')){
                          notification.error({message:`Postal code already available for the selected special territory. Please remove from existing code and insert to the new postal code.`, duration:4})
                      }
                      else if(data.message.includes('foreign')){
                          notification.error({message:`Inserted Special Territory is not available. Please insert to the Special Territory table and try again.`, duration:4})
                      }
                      return true;
                  }}  />
        </Modal>


    </React.Fragment>
};